import React, { useState, useEffect } from "react";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import {
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
  TABLE,
  LEFTTABLE,
  THTABLE,
  RIGHTTABLE,
  TRTABLE,
  TXCENTER,
} from "../../../../utils/useStyle";
import { ExcelAvgAttempt } from "../../functions/Report.ExportAvgAttempt";

const calculateAverage = (arr) => {
  if (!arr || arr.length === 0) return 0;
  const filtered = arr.filter((val) => !isNaN(val) && val !== null);
  if (filtered.length === 0) return 0;
  const sum = filtered.reduce((acc, val) => acc + val, 0);
  return (sum / filtered.length).toFixed(2);
};

const ReportAverageTime = ({ userDept }) => {
  const [statData, setStatData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = useState({
    label: "-",
    value: "NONE",
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getAvgTimeReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
      
        if (response?.success) {
          setData(response.data);
          setStatData(response.statData || []);
        }
      } catch (error) {
        console.error("Error fetching average time report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const calculateAverageForDoctors = (data) => {
    return data?.map((doctor) => {
      // Calculate the average checkTime for each doctor using the calculateAverage function
      const averageCheckTime = calculateAverage(
        doctor?.checkTime?.map((time) => parseFloat(time))
      ); // Ensure time values are numbers
      return {
        ...doctor, // Spread the original doctor object to retain other properties
        averageCheckTime, // Add the calculated average checkTime
      };
    });
  };

  const updatedDataWithAverage = calculateAverageForDoctors(data);

  const averageCheckTimeArray = updatedDataWithAverage?.map(
    (doctor) => parseFloat(doctor.averageCheckTime)
  );
  const useSumAll = averageCheckTimeArray.filter((value) => value !== 0);
  const submitExcelData = updatedDataWithAverage?.map((item) => {
    return {
      doctor: item?.doctor,
      averageCheckTime: item?.averageCheckTime,
    };
  });

  const maxAverageCheckTime = Math.max(...useSumAll);
  const minAverageCheckTime = Math.min(...useSumAll);
  const averageOfAll = calculateAverage(useSumAll);

  return (
    <div className="my-20">
      <div className={SCREENIPAD}>
        <div className={STYLEHEAD}>
          เวลาเฉลี่ยของทุก attempt แยกตามแพทย์ผู้ใส่
          <div className={STYLEBODY}>
            ของปี{year?.label}ตามประเภทสาย {type?.label}
          </div>
        </div>
        <div className={FLEXDROPDOWN}>
          <FilterYearType
            year={year}
            setYear={setYear}
            type={type}
            setType={setType}
          />
          <ButtonExcel
            onClick={() => {
              ExcelAvgAttempt(submitExcelData, year, type, setLoading);
            }}
            loading={loading}
          />
        </div>
      </div>

      <div className="flex mt-2">
        <div className="rounded-xl border border-b p-2 m-2 ml-0">
          ค่าเฉลี่ย = {averageOfAll}
        </div>
        <div className="rounded-xl border border-b p-2 m-2">
          {" "}
          min = {minAverageCheckTime}
        </div>
        <div className="rounded-xl border border-b p-2 m-2">
          {" "}
          max = {maxAverageCheckTime}
        </div>
      </div>

      <table className={TABLE}>
        <tr>
          <th className={LEFTTABLE}>ลำดับที่</th>
          <th className={THTABLE}> ชื่อ </th>
          <th className={RIGHTTABLE}> ค่าเฉลี่ยของทุก attempt (นาที) </th>
        </tr>
        <tbody>
          {updatedDataWithAverage?.map((item, index) => (
            <tr key={index} className={TRTABLE}>
              <th className={TXCENTER}> {index + 1}</th>
              <td className={TXCENTER}> {item?.doctor}</td>
              <td className={TXCENTER}>{item?.averageCheckTime}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportAverageTime;
